var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKraken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#5741d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.14 584.42c0-9.75.17-19.49-.06-29.24a292.47 292.47 0 0 1 4.07-56.2c5.4-31.14 15.21-60.54 31.25-87.73C318.3 365.58 356.23 332 404 309.49a239.35 239.35 0 0 1 66.67-20.61c12.09-1.84 24.23-3.34 36.54-3.23 52.3.39 101 13.31 145 42.16 43.11 28.29 75.47 65.72 94.91 113.79a276.71 276.71 0 0 1 17.72 70.4c3.29 26.68 3.45 53.47 3 80.32-.28 14.48-.22 29-.45 43.44-.11 6.29-.33 12.59-2 18.77-6.52 24-33.92 34.92-54 21.61-9-5.9-13.42-14.59-15-25a133.05 133.05 0 0 1-1.67-21.05V542.7c0-11.42-3.56-21.56-11.36-30-13.65-14.65-34.59-15.21-49.91-1.67-8.58 7.63-12.48 17.32-13.31 28.46-.33 4.18-.45 8.35-.45 12.53-.06 32.14.06 64.22-.17 96.36-.17 18.21-14 32.14-32.58 33.42a34.46 34.46 0 0 1-36.54-28.57 86.3 86.3 0 0 1-1.11-14.7c0-32.31.06-64.61 0-96.92a40.2 40.2 0 0 0-11.31-28.52c-15.32-16.1-38.38-15.6-53.25.95-7.3 8.08-10.47 17.49-10.47 28.24 0 31.92-.06 63.89 0 95.8 0 8.24-1 16.32-4.4 23.89a33.7 33.7 0 0 1-32.64 20.33c-13.65-.45-25.18-9-30.41-22.73a47 47 0 0 1-3-16.88q.08-46.37-.06-92.74c0-6.85-.28-13.76-2.34-20.39-4.68-15.21-14.82-24.9-30.47-27.46-15.93-2.62-27.74 4.9-36.59 17.71-4.23 6.13-5.63 13-5.63 20.33q0 44 .06 88c0 8.63.17 17.27-1.78 25.79-3.23 14.15-16.82 29.58-37.37 28.07-14.15-1.06-27.74-12.76-31.69-27.74a64.22 64.22 0 0 1-1.94-16.21c.17-18 .17-35.81.11-53.64z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKraken);
export default __webpack_public_path__ + "static/media/kraken.1d29b261bf076e346e72c1e35e8e5cdc.svg";
export { ForwardRef as ReactComponent };